/* Aperçu sur place des documents d'une fiche produit (H2, vague 5, 23/10/2026) : fiche technique du fabricant et guide des tailles.
   Tout élément [data-ask-apercu="<id d'une fenêtre .ask-ap>"] l'ouvre : ligne des documents sous les photos portées
   (snippets/ask-fiche-mannequins.liquid), raccourcis et accordéon « Quelle taille choisir ? » (sections/product-accordions.liquid).
   - Les images des fenêtres (data-src) ne se chargent qu'à l'ouverture : rien de plus au chargement de la fiche.
   - Sans la fenêtre (autre modèle) : un lien garde son comportement (ancre vers l'accordéon, ou nouvel onglet) ; une ancre
     vers un <details> l'ouvre.
   - Zoom : un toucher sur une page, ou le bouton loupe, passe les pages à leur taille réelle ; la fenêtre défile alors dans
     les deux sens, centrée sur l'endroit touché. Un second toucher revient à la largeur de la fenêtre.
   - Fermeture : bouton, Échap (natif) ou toucher sur le fond. Le navigateur rend le focus à l'élément qui a ouvert la fenêtre.
   Délégation sur le document : rien à rattacher quand Dawn remplace la colonne au changement de variante.
   Correcteur H2 (après le casseur) : quand aucune page n'est plus large que la place qu'elle a déjà dans la fenêtre (petite
   image, ou grand écran), il n'y a rien à agrandir : la loupe et la phrase « Touchez / Cliquez … pour l'agrandir » sont
   masquées (classe ask-ap--fixe) et un toucher sur la page ne fait rien. Recalculé à l'ouverture et quand la fenêtre change
   de taille (rotation du téléphone). */
(function () {
  if (window.__askAp) return;
  window.__askAp = true;

  function charger(d) {
    Array.prototype.forEach.call(d.querySelectorAll('[data-src]'), function (el) {
      if (el.getAttribute('data-srcset')) { el.setAttribute('srcset', el.getAttribute('data-srcset')); el.removeAttribute('data-srcset'); }
      el.setAttribute(el.tagName === 'OBJECT' ? 'data' : 'src', el.getAttribute('data-src'));
      el.removeAttribute('data-src');
    });
  }

  function zoom(d, actif, page, ex, ey) {
    var corps = d.querySelector('.ask-ap__corps');
    var btn = d.querySelector('[data-ask-ap-zoom]');
    d.classList.toggle('ask-ap--zoom', actif);
    if (btn) {
      btn.setAttribute('aria-pressed', actif ? 'true' : 'false');
      btn.setAttribute('aria-label', actif ? 'Revenir à la largeur de la fenêtre' : (btn.getAttribute('data-libelle') || 'Agrandir'));
    }
    if (!corps) return;
    if (!actif) {
      // la page touchée reste à l'écran
      if (page) corps.scrollTop = Math.max(0, page.offsetTop - 12);
      corps.scrollLeft = 0;
      return;
    }
    if (page && typeof ex === 'number') {
      // après agrandissement, l'endroit touché vient au centre de la fenêtre
      requestAnimationFrame(function () {
        var w = page.offsetWidth, h = page.offsetHeight;
        corps.scrollLeft = Math.max(0, page.offsetLeft + ex * w - corps.clientWidth / 2);
        corps.scrollTop = Math.max(0, page.offsetTop + ey * h - corps.clientHeight / 2);
      });
    }
  }

  // Une page est « agrandissable » si sa taille réelle (attribut width, celle qu'elle prend une fois agrandie) dépasse la place
  // qu'elle a dans la fenêtre (largeur intérieure du corps, marges déduites).
  function majFixe(d) {
    var corps = d.querySelector('.ask-ap__corps');
    var pages = d.querySelectorAll('.ask-ap__page');
    if (!corps || !pages.length) { d.classList.remove('ask-ap--fixe'); return; }
    var cs = getComputedStyle(corps);
    var dispo = corps.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    if (dispo <= 0) return;
    var utile = false;
    Array.prototype.forEach.call(pages, function (pg) {
      var w = parseInt(pg.getAttribute('width'), 10) || pg.naturalWidth || 0;
      if (w > dispo + 2) utile = true;
    });
    if (!utile && d.classList.contains('ask-ap--zoom')) zoom(d, false);
    d.classList.toggle('ask-ap--fixe', !utile);
  }

  function ouvrir(id) {
    var d = document.getElementById(id);
    if (!d || !d.classList.contains('ask-ap') || typeof d.showModal !== 'function') return false;
    charger(d);
    zoom(d, false);
    var html = document.documentElement;
    html.classList.toggle('ask-ap-gouttiere', window.innerWidth - html.clientWidth > 0);
    if (!d.open) d.showModal();
    majFixe(d);
    var corps = d.querySelector('.ask-ap__corps');
    if (corps) { corps.scrollTop = 0; corps.scrollLeft = 0; }
    return true;
  }

  var attente;
  window.addEventListener('resize', function () {
    clearTimeout(attente);
    attente = setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('.ask-ap[open]'), majFixe);
    }, 150);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var declencheur = t.closest('[data-ask-apercu]');
    if (declencheur) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return; // ouverture voulue dans un autre onglet
      if (ouvrir(declencheur.getAttribute('data-ask-apercu'))) { e.preventDefault(); return; }
      // pas de fenêtre sur cette page : une ancre vers un accordéon l'ouvre
      var h = declencheur.getAttribute('href') || '';
      if (h.charAt(0) === '#') {
        var cible = document.getElementById(h.slice(1));
        if (cible && cible.tagName === 'DETAILS') cible.open = true;
      }
      return;
    }
    var d = t.closest('.ask-ap');
    if (!d) return;
    if (t === d || t.closest('[data-ask-ap-fermer]')) { d.close(); return; }
    if (d.classList.contains('ask-ap--fixe')) return;
    var b = t.closest('[data-ask-ap-zoom]');
    if (b) {
      var premiere = d.querySelector('.ask-ap__page');
      zoom(d, !d.classList.contains('ask-ap--zoom'), premiere, 0, 0);
      return;
    }
    var page = t.closest('.ask-ap__page');
    if (page) {
      var r = page.getBoundingClientRect();
      var ex = r.width ? (e.clientX - r.left) / r.width : 0.5;
      var ey = r.height ? (e.clientY - r.top) / r.height : 0.5;
      zoom(d, !d.classList.contains('ask-ap--zoom'), page, ex, ey);
    }
  });

  document.addEventListener('close', function (e) {
    var d = e.target;
    if (d && d.classList && d.classList.contains('ask-ap')) zoom(d, false);
  }, true);
})();
